import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input, TextArea, Checkbox } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { CustomDropdown } from "../shared/customDropdown";
import { alertService } from '../../services/helpers/alert.service';
import { partnerService } from '../../services/api/partner.service';
import { nomService } from '../../services/api/nom.service';
import { mmRecordService } from '../../services/api/mmRecord.service';
import { reportService } from "../../services/api/report.service";
import { utils } from "../../services/helpers/utils";
import { MMRecordNoxes } from "./mmRecordNoxes";
import { MMRecordFiles } from "./mmRecordFiles";
import { MMRecordInvestigations } from "./mmRecordInvestigations";
import { MMRecordRecomandations } from "./mmRecordRecomandations";
import { MMRecordDiagnostics } from "./mmRecordDiagnostics";


export const MMRecord = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();

    const partener = sessionStorage.getItem("idPartener");
    const rol = sessionStorage.getItem("rol");

    const [doRender, setDoRender] = useState(false);

    const param = {
        pacient: searchParams.get("pacient"),
        contract: searchParams.get("contract"),
        idFisa: searchParams.get("id"),
    };

    const [isModified, setIsModified] = useState(false);
    const [IDFisa, setIDFisa] = useState(param.idFisa);
    const [fisa, setFisa] = useState({});

    // Listele de investigatii, diagnostice si fisiere
    const [noxe, setNoxe] = useState([]);
    const [investigatiiNoxe, setInvestigatiiNoxe] = useState([]);
    const [investigatii, setInvestigatii] = useState([]);
    const [recomandari, setRecomandari] = useState([]);
    const [diagnostice, setDiagnostice] = useState([]);
    const [fisiere, setFisiere] = useState([]);

    // Daca este apt sau nu
    const [isApt, setIsApt] = useState(true);

    // Daca are diagnostic cu restrictie de tip Z00 sau Z10
    const [haveRestrictionDiagnostic, setHaveRestrictionDiagnostic] = useState(false);


    // Dupa salvare se vor forta toate componentele sa se reafiseze pentru a-si actualiza id-urile
    const [refresh, setRefresh] = useState(false);

    // Datele din DB nu trebuie afectate de onChange pana nu s-a finalizat incarcarea.
    // Flag sugestiv: true = incarcare in curs, protejam datele; false = incarcare finalizata.
    const loadingDatainProgress = useRef(false);

    useEffect(() => {
        if (param.idFisa) {
            loadingDatainProgress.current = true;
            mmRecordService.getMMRecord({ recordId: param.idFisa }).then((response) => {
                if (response) {
                    setFisa(response);
                    setDoRender(true);
                } else {
                    loadingDatainProgress.current = false;
                }
            })
            .finally(() => {
                loadingDatainProgress.current = false;
            });                
        } else if (param.pacient && param.contract) {
            mmRecordService.getHeader({
                pacient: param.pacient,
                subscription: param.contract,
                partener: partener
            })
                .then(response => {
                    if (response) {
                        setFisa(response);
                        setDoRender(true);
                    }
                });
        }
    }, []);

    // 
    useEffect(() => {
        setIsModified(false);
    }, []);



    const handleChange = (event) => {

        let value = (event.target.type === 'checkbox') ? event.target.checked : event.target.value;
        const name = event.target.name;

        // Daca nu exista proprietatea in obiectul fisa
        if (!fisa.hasOwnProperty(name)) {
            return;
        }

        if (name === 'supraveghereSpeciala' || name === 'statusFinanciar') {
            value = (value ? 1 : 0);
        }

        // daca value e obiect 
        if (typeof value === "object") {
            // Daca are id e dropdown
            if (value && value.hasOwnProperty("id")) {
                if (fisa[name] === value.id) {
                    return;
                }
                setFisa((prevParams) => ({ ...prevParams, [name]: value.id }));
            }
            // Daca nu are id e data
            else {
                setFisa((prevParams) => ({ ...prevParams, [name]: value }));
            }
        }
        else {
            setFisa((prevParams) => ({ ...prevParams, [name]: value }));
        }

        console.log(fisa);
        setIsModified(true);
    }

    const handleChangeDataEmitere = (event) => {
        setIsModified(true);
        const { name, value } = event.target;
        setFisa((prevParams) => ({ ...prevParams, [name]: value }));

        // Nu lasam onChange sa suprascrie data urmatorului control atata timp cat incarcarea din DB nu s-a finalizat.
        // La primul onChange dupa incarcare (eventual declansat de DatePicker la primirea valorii), consideram incarcarea finalizata.
        if (loadingDatainProgress.current) {
            loadingDatainProgress.current = false;
        } else {
            let DataUrmatoruluiControl = utils.addOneYear(new Date(value));
            setFisa((prevParams) => ({ ...prevParams, dataUrmatorControl: DataUrmatoruluiControl }));
        }
    }

    const handleChangeFunctie = (event) => {
        setIsModified(true);
        const { name, value } = event.target;
        setFisa((prevParams) => ({ ...prevParams, [name]: value.id }));
        if (!fisa.aliasProfesie) {
            setFisa((prevParams) => ({ ...prevParams, aliasProfesie: value.text }));
        }

    }

    const updateRisc = (value) => {
        setIsModified(true);
        setFisa((prevParams) => ({ ...prevParams, cuRisc: value }));
    }



    const saveVerify = () => {
        if (fisa.idTipFisa == null) {
            alertService.error("Completati coloana Tip fisa!");
            return false;
        }

        if (fisa.idFunctieCor == null) {
            alertService.error("Completati coloana Cod cor!");
            return false;
        }

        if (!fisa.dataUrmatorControl) {
            alertService.error("Completati data urmatorului control!");
            return false;
        }

        if (fisa.efectuatIn == null) {
            alertService.error("Completati coloana Efectuat in!");
            return false;
        }


        let dataLimita = new Date();
        dataLimita.setFullYear(dataLimita.getFullYear() + 1);
        dataLimita.setDate(dataLimita.getDate() - 1);

        if (fisa.dataUrmatorControl && fisa.dataUrmatorControl > dataLimita) {
            alertService.error("Data urmatorului control nu poate depasi un an incepand de azi!");
            return false;
        }

        if (noxe.length > 0) {
            for (var i = 0; i < noxe.length; i++) {
                if (!noxe[i].idNoxa) {
                    alertService.error("Completati noxa de la randul " + (i + 1) + "!");
                    return false;
                }
            }
        }


        if (investigatii.length > 0) {
            for (var i = 0; i < investigatii.length; i++) {
                if (!investigatii[i].idInvestigatie) {
                    alertService.error("Completati investigatia de la randul " + (i + 1) + "!");
                    return false;
                }

                if (!investigatii[i].dataEfectuarii) {
                    alertService.error("Completati data efectuarii in lista de investigatii recomandate, la randul " + (i + 1) + "!");
                    return false;
                }
            }
        }


        if (investigatiiNoxe.length > 0) {
            for (var i = 0; i < investigatiiNoxe.length; i++) {
                if (!investigatiiNoxe[i].dataEfectuarii) {
                    alertService.error("Completati data efectuarii in lista de investigatii obligatorii, la randul " + (i + 1) + "!");
                    return false;
                }
            }
        }



        if (diagnostice.length > 0) {
            for (var i = 0; i < diagnostice.length; i++) {
                if (!diagnostice[i].idDiagnostic) {
                    alertService.error("Completati diagnosticul de la randul " + (i + 1) + "!");
                    return false;
                }
            };
        }


        if (recomandari.length > 0) {
            for (var i = 0; i < recomandari.length; i++) {

                if (!recomandari[i].idRezolutie) {
                    alertService.error("Completati aptitudinea de la randul " + (i + 1) + "!");
                    return false;
                }


            };
        }

        if (isApt != true && haveRestrictionDiagnostic == true) {
            alertService.error("Pentru oricare aviz medical cu exceptia APT nu se pot selecta diagnostice din grupele Z00 sau Z10!");
            return false;
        }



        return true;

    }

    const completeVerify = () => {

        if (fisa.dataEmitere == null) {
            alertService.error("Completati coloana: Data emitere!");
            return false;
        }

        if (fisa.idMedic == null) {
            alertService.error("Completati coloana: Emis de!");
            return false;
        }

        if (fisa.idProfesie == null) {
            alertService.error("Completati coloana: Functie!");
            return false;
        }

        if (!fisa.idLocatie) {
            alertService.error("Completati coloana: Locatie!");
            return false;
        }

        if (recomandari.length == 0) {
            alertService.error("Nu ati adaugat recomandarea!");
            return false;
        }

        if (diagnostice.length == 0) {
            alertService.error("Nu ati adaugat diagnosticul!");
            return false;
        }

        //if (fisiere.length == 0) {
        //    alertService.error("Nu ati adaugat fisiere!");
        //    return false;
        //}

        return true;
    }



    const handleSave = (saveParam) => {
        const isVerify = saveVerify();
        if (!isVerify) {
            setFisa(prevParams => ({ ...prevParams, statusFinalizare: 0 }));
            return;
        }

        let saveFisa = (saveParam.hasOwnProperty("id") ? saveParam : fisa);

        const isFinalizata = (saveFisa.statusFinalizare == 1);

        let investigatiiAll = [...investigatii];
        investigatiiAll.push(...investigatiiNoxe);


        const formData = new FormData();
        utils.convertObject(formData, saveFisa, 'fisa');
        utils.convertArray(formData, noxe, 'noxe');
        utils.convertArray(formData, investigatiiAll, 'investigatii');
        utils.convertArray(formData, recomandari, 'recomandari');
        utils.convertArray(formData, diagnostice, 'diagnostice');
        convertFiles(formData, fisiere, 'fisiere');


        mmRecordService.saveMMRecord(formData).then(response => {
            if (response) {                
                setFisa(prevParams => ({
                    ...prevParams,
                    id: response.id,
                    nrFisa: response.nrFisa
                }));
                setRefresh(!refresh); // Fortez refersul componentelor
                setIDFisa(response.id);
                setIsModified(false);

                if (isFinalizata) {
                    if (response.runReportOnCompleted) {
                        handleRaportFisaMM(response.id)
                            .then(() => {
                                alertService.success("Fisa a fost finalizata cu succes!");
                            });
                    }
                    else {
                        alertService.success("Fisa a fost finalizata cu succes!");
                    }
                }
                else {
                    alertService.success("Fisa a fost salvata cu succes!");
                }

                return true;
            }
            else {  
                if (isFinalizata) {
                    setFisa(prevParams => ({ ...prevParams, statusFinalizare: 0 }));
                    return false
                }
            }
        });
    };

    const handleCompletion = () => {
        if (fisa.statusFinalizare == 1) {
            return;
        }

        const isCompleteVerify = completeVerify();
        if (!isCompleteVerify) {
            return;
        }
        const newFisa = { ...fisa, statusFinalizare: 1 };
        setFisa(newFisa);

        handleSave(newFisa)

    }


    const convertFiles = (formData, list, path) => {
        for (var i = 0; i < list.length; i++) {
            var file = {
                Id: list[i].id ?? 0,
                IdFisa: list[i].idFisa ?? 0,
                Description: list[i].descriere,
                File: list[i].rawFile
            };
            utils.convertObject(formData, file, `${path}[${i}]`);
        }
    }


    const handlePrintFA = () => {
        if ((fisa.id ?? 0) == 0) {
            alertService.error("Salvati mai intai!");
            return;
        }

        if (fisa.idExternalDocument > 0) {
            handleGetFA()
        }
        else {
            handleRaportFisaMM(fisa.id);
        }
    };

    const handleGetFA = () => {
        return mmRecordService
            .downloadFisaMM({ fisa: fisa.id })
            .then((response) => {
                if (response) {
                    utils.downloadFile(response, "application/pdf");
                    return;
                }
            });
    } 

    const handleRaportFisaMM = (idFisa) => {
        return reportService
            .RaportFisaMM({ fisa: idFisa })
            .then((response) => {
                if (response) {
                    utils.downloadFile(response, "application/pdf");
                    return;
                }
            });
    };

    const handleMedicalLetter = () => {
        if ((fisa.id ?? 0) == 0) {
            alertService.error("Salvati mai intai!");
            return;
        }
        reportService.RaportScrisoareMedicala({ fisa: fisa.id }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/pdf");
                return;
            }
        });
    };

    const handleClose = () => {
        if (fisa.statusFinalizare == 1 || rol == 2) {
            navigate(-1);
            return;
        }
        if (isModified) {
            alertService.confirm("Atentie", "Datele au fost modificate. Renuntati la modificari?",
                () => { navigate(-1); },
                () => { return });
        }
        else {
            navigate(-1);
        }
        return;
    };


    return (
        <>
            { fisa.statusFinalizare == 0 &&
              fisa.showMessage == 1 &&
              <p className="msg-alert">Fisa se va putea finaliza doar de catre medicul completat in campul "Emis de"!</p >
            }

            <h2 className="pt20 pb10">Fisa MM</h2>
            <p className="paragraf"></p>
            <hr />

            <div className="formular">
                <h3 className="pb5">
                    <span name="nume_pacient">{fisa.numePacient} - {fisa.codPacient }</span>
                </h3>
                <div className="clearfix">
                    <div className="fl">
                        <fieldset className="hidden-fildset">
                            <p>
                                Data si ora inregistrarii:
                                <span name="datareg_date">{fisa.dataOraInregistrare ? (fisa.dataOraInregistrare + "").substring(0, 16) : fisa.dataOraInregistrare }</span>
                            </p>
                            <p>
                                <span name="status_finalizare">{fisa.statusFinalizare == 0 ? "Nefinalizata" : "Finalizata"} </span>
                            </p>
                            <label className="pt10 pb5">Tip abonament:</label>
                            <Input
                                className="greybg"
                                name="abonament"
                                readOnly
                                value={fisa.abonament ?? ""}
                            />

                            <label className="pt10 pb5">Detalii abonament:</label>
                            <TextArea
                                className="greybg notebox"
                                name="note"
                                value={`Nota pacient: ${fisa.notaPacient ?? ""} \nNota firma: ${fisa.notaFirma ?? ""}`}
                                readOnly
                                rows={8}
                            />

                            <label className="pt10 pb5">Cu risc:</label>
                            <Input
                                className="greybg"
                                name="cu_risc" readOnly
                                value={((fisa.cuRisc ?? -1) == -1) ? "" : (fisa.cuRisc == 0 ? "Nu" : "Da")} 
                                
                                />
                                
                            <div className="pt10 pb5">
                                Supraveghere speciala:
                                <Checkbox name="supraveghereSpeciala"
                                    value={fisa.supraveghereSpeciala == 1 ? true : false}
                                    onChange={handleChange}
                                    disabled={fisa.statusFinalizare == 1 || rol == 2}
                                />
                            </div>
                            <div className="pt10 pb5">
                                Financiar:
                                <Checkbox name="statusFinanciar"
                                    value={fisa.statusFinanciar == 1 ? true : false}
                                    onChange={handleChange}
                                    disabled={fisa.statusFinalizare == 1 || rol == 2}
                                />
                            </div>

                            <label className="pt10 pb5">
                                Functie: <span className="red">*</span>
                            </label>
                            <div className="clearfix">
                                <CustomDropdown
                                    className="text"
                                    name="idProfesie"
                                    request={nomService.getProfessionsByContract}
                                    requestParams={{ contract: fisa.idAbonament ?? 0 }}
                                    initialValue={fisa.idProfesie}
                                    onChangeEvent={handleChangeFunctie}
                                    disabled={fisa.statusFinalizare == 1 || rol == 2}
                                    isSearcheable={true}
                                    filterable
                                />
                            </div>
                            <label className="pt10 pb5">
                                Cod cor: <span className="red">*</span>
                            </label>
                            <div className="clearfix">
                                <CustomDropdown
                                    className=""
                                    name="idFunctieCor"
                                    request={nomService.getCorFunctions}
                                    initialValue={fisa.idFunctieCor}
                                    onChangeEvent={handleChange}
                                    disabled={fisa.statusFinalizare == 1 || rol == 2}
                                />
                            </div>

                            <label className="pt10 pb5">Alias profesie:</label>
                            <TextArea
                                name="aliasProfesie"
                                className=""
                                rows={3}
                                maxLength={200}
                                value={fisa.aliasProfesie ?? ""}
                                onChange={handleChange}
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                            />

                            <label className="pt10 pb5">
                                Emis de: <span className="red">*</span>
                            </label>
                            <CustomDropdown
                                className=""
                                name="idMedic"
                                request={partnerService.getMMDoctors}
                                requestParams={{ partener: (param.idFisa ? fisa.idPartener : partener) }}
                                doRender={doRender}
                                initialValue={fisa.idMedic}
                                onChangeEvent={handleChange}
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                            />

                            <label className="pt10 pb5">Post si loc de munca:</label>
                            <TextArea
                                name="post"
                                className=""
                                rows={3}
                                maxLength={300}
                                value={fisa.post ?? ""}
                                onChange={handleChange}
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                            />
                        </fieldset>
                    </div>

                    <div className="fr">
                        <fieldset className="hidden-fildset">
                            <label className="pb5">Partener:</label>
                            <Input
                                className=""
                                name="numePartener"
                                data-label="Partener"
                                readOnly
                                value={fisa.numePartener ?? ""}
                            />

                            <label className="pb5 pt10">Locatie:</label>
                            <CustomDropdown
                                className="text"
                                name="idLocatie"
                                request={partnerService.getLocations}
                                requestParams={{ partener: (param.idFisa ? fisa.idPartener : partener) }}
                                initialValue={fisa.idLocatie}
                                onChangeEvent={handleChange}
                                doRender={doRender} 
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                            />

                            <label className="pt10 pb5">Data deschidere:</label>
                            <DatePicker
                                className=""
                                name="dataDeschidere"
                                value={utils.convert2DatePickerDate(fisa.dataDeschidere)}
                                max={new Date()}
                                onChange={handleChange}
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                            />

                            <label className="pt10 pb5">Data emitere:</label>
                            <DatePicker
                                className=""
                                name="dataEmitere"
                                value={utils.convert2DatePickerDate(fisa.dataEmitere)}
                                max={new Date()}
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                                onChange={handleChangeDataEmitere}
                            />

                            <label className="pt10 pb5">Data urmatorului control:  <span className="red">*</span></label>
                            <DatePicker
                                className=""
                                name="dataUrmatorControl"
                                value={utils.convert2DatePickerDate(fisa.dataUrmatorControl)}
                                disabled={fisa.statusFinalizare == 1 || rol == 2}
                                onChange={handleChange}
                            />

                            <label className="pt10 pb5">Numar fisa:</label>
                            <Input
                                className=""
                                name="nrFisa"
                                value={fisa.nrFisa ?? ""}
                                readOnly={ true }
                                disabled={true}
                            />

                            <label className="pt10 pb5">
                                Tip fisa: <span className="red">*</span>
                            </label>
                            <div className="clearfix">
                                <CustomDropdown
                                    className=""
                                    name="idTipFisa"
                                    request={nomService.getRrecordsType}
                                    initialValue={fisa.idTipFisa}
                                    onChangeEvent={handleChange}
                                    disabled={fisa.statusFinalizare == 1 || rol == 2}
                                />
                            </div>

                            <label className="pt10 pb5">Numar vechi:</label>
                            <Input className=""
                                name="nr_vechi"
                                value={fisa.nrVechi ?? ""}
                                disabled={true}
                            />

                            <div className="pt10 pb5">
                                Fisa reemisa:
                                <Checkbox
                                    name="fisa_reemisa"
                                    value={fisa.fisaReemisa == 1 ? true : false }
                                    disabled={true} />
                            </div>
                            <div className="pt10 pb5">
                                Facturat:
                                <Checkbox name="status_facturare"
                                    disabled={true}
                                    value={fisa.statusFacturare == 1 ? true : false} />
                            </div>
                            <label className="pt10 pb5">Numar preaprobare:</label>
                            <Input
                                className=""
                                name="id_preautorizare"
                                disabled={true}
                                value={fisa.idPreautorizare ?? ""}
                            />

                            <label className="pt10 pb5">Status fisa:</label>
                            <div className="clearfix">
                                <CustomDropdown
                                    className=""
                                    name="statusFisa"
                                    request={nomService.getMMRecordStatus}
                                    initialValue={fisa.statusFisa}
                                    onChangeEvent={handleChange}
                                    disabled={fisa.statusFinalizare == 1 || rol == 2}
                                />
                            </div>

                            <div className="pt10 pb5">
                                <label className="pb5">Efectuat in:  <span className="red">*</span></label>
                                <CustomDropdown
                                    name="efectuatIn"
                                    className="text fl"
                                    data={[{ id: 0, text: "Clinica" }, { id: 1, text: "Teren" }]}
                                    value={ fisa.efectuatIn != 0 && fisa.efectuatIn != 1 ? {id:null, text:""} : ( fisa.efectuatIn == 0 ? {id: 0, text: "Clinica" } : {id: "N", text: "Teren" }) }
                                    initialValue={fisa.efectuatIn}
                                    onChangeEvent={handleChange}
                                    disabled={fisa.statusFinalizare == 1}
                                />
                            </div>

                        </fieldset>
                    </div>
                </div>
                
                {(fisa && fisa.statusFisa == 0) &&
                    < MMRecordNoxes
                    idFisa={fisa.id}
                    finalizare={fisa.statusFinalizare}
                    tipFisa={fisa.idTipFisa}
                    setNoxe={setNoxe}
                    updateRisc={updateRisc}
                    setInvestigatiiNoxe={setInvestigatiiNoxe}
                    financiar={fisa.statusFinanciar}
                    idLocatie={fisa.idLocatie}
                    refresh={ refresh}
                    />}

                <MMRecordInvestigations
                    idFisa={IDFisa}
                    finalizare={fisa.statusFinalizare}
                    setInvestigatii={setInvestigatii}
                    setIsModified={setIsModified}
                    financiar={fisa.statusFinanciar}
                    idLocatie={fisa.idLocatie}
                    dataDeschidere={fisa.dataDeschidere}
                    refresh={refresh}
                /> 

                <MMRecordRecomandations
                    idFisa={IDFisa}
                    finalizare={fisa.statusFinalizare}
                    setRecomandari={setRecomandari}
                    setIsModified={setIsModified}
                    refresh={refresh}
                    setIsApt={setIsApt}
                    haveRestrictionDiagnostic={haveRestrictionDiagnostic}
                />
                    

                <MMRecordDiagnostics
                    idFisa={IDFisa}
                    finalizare={fisa.statusFinalizare}
                    setDiagnostice={setDiagnostice}
                    setIsModified={setIsModified}
                    refresh={refresh}
                    setHaveRestrictionDiagnostic={setHaveRestrictionDiagnostic}
                    isApt={isApt}
                />
                    
                <MMRecordFiles
                    idFisa={IDFisa}
                    finalizare={fisa.statusFinalizare}
                    setFisiere={setFisiere}
                    setIsModified={setIsModified}
                    partener={fisa.id ? fisa.idPartener : partener}
                    refresh={refresh}
                />

                <div className="pt30 pb20 clearfix">
                    <div className="fl">
                        <button className="btn" name="back" onClick={handleClose}>
                            Inchide
                        </button>
                    </div>
                    <div className="fr text-right">
                        <button
                            className="btn"
                            name="scrisoare-medicala"
                            onClick={handleMedicalLetter}
                        >
                            Scrisoare medicala
                        </button>
                        <button className="btn" name="tipareste" onClick={handlePrintFA}>Tipareste FA</button>
                        
                        {
                            !fisa.statusFinalizare && rol != 2 &&
                            (<>
                                <button className="btn" name="save" onClick={handleSave}>Salveaza</button>
                                <button className="btn" name="finalizeaza" onClick={handleCompletion }>Finalizeaza</button>
                            </>)
                        }
                    </div>
                </div>
            </div>
        </>
    );
};
